export default "__VITE_ASSET__B7Wynb6d__"